"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RolesInfo = /** @class */ (function () {
    function RolesInfo(key, text) {
        this.key = key;
        this.text = text;
    }
    return RolesInfo;
}());
exports.RolesInfo = RolesInfo;
//# sourceMappingURL=RolesInfo.js.map